import React from 'react'
import Divider from '@components/Divider'
import MemphisPattern from '@components/MemphisPattern'
import Navigation from '@components/Navigation'
import PageTitle from '@components/PageTitle'
import attachSocialIcons from '@helpers/attachSocialIcons'
import { Layout, Stack, Main, Sidebar } from '@layout'
import Seo from '@widgets/Seo'
import { Badge, Box, Card, Flex, Heading, Text } from 'theme-ui'
import { Card as CardComponent } from 'theme-ui'

import getImageVariant from '@components/utils/getImageVariant'
import { GatsbyImage as Img } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import { css } from 'theme-ui'

//Base size to keep all layers aligned easier

const styles = {
  card: {
    position: `relative`
  },
  wrapper: {
    flexDirection: [`column`, `row`],
    position: `relative`,
    zIndex: 3
  },
  avatarColumn: {
    flexBasis: `1/5`
  },
  infoColumn: {
    flexBasis: `4/5`
  },
  innerBox: {
    flexBasis: `1/2`,
    flexGrow: 1,
    px: [0, 3],
    mt: [3, 0]
  },
  subheader: {
    color: `omegaDark`
  },
  name: {
    textAlign: [`center`, `left`],
    mt: [3, 0],
    px: 3
  },
  bio: {
    textAlign: [`center`, `left`]
  },
  socialList: {
    a: {
      m: 0
    }
  },
  link: {
    position: `absolute`,
    top: 10,
    right: 10,
    zIndex: 3
  },
  pattern: {
    borderRadius: `lg`
  },
  gradient: {
    size: `full`,
    borderRadius: `lg`,
    position: `absolute`,
    left: 0,
    top: 0,
    zIndex: 2,
    background: [
      t =>
        `linear-gradient(0deg, ${t.colors.contentBg} 20%, rgba(255, 255, 255, 0) 80%)`,
      t =>
        `linear-gradient(270deg, ${t.colors.contentBg} 20%, rgba(255, 255, 255, 0) 100%)`
    ]
  },
}

const tableStyle = {
  borderCollapse: 'collapse',
  width: '100%',
};

const thTdStyle = {
  border: '1px solid black',
  padding: '8px',
};


const PageContact = props => {
  return (
    <Layout {...props}>
      <Seo title='モラル傷害の予防に焦点を当てた自殺予防支援者の心理的支援プログラムの開発と検証' />
      <Divider />
      <Stack>
        <Main>
          <PageTitle
            header='モラル傷害の予防に焦点を当てた自殺予防支援者の心理的支援プログラムの開発と検証'
            subheader=''
          />
          <CardComponent variant='paper'>
            <div style={{padding: "0 2rem"}}>
            <Heading as='h2'>１．目的</Heading>
            <Text>
            　 本研究では、コロナ禍で自殺率の増加が世界的に懸念されていること、及び支援者のメンタルヘルス悪化の要因の一つとして、社会情勢の変化等の不条理な事態でモラルが傷つく「モラル傷害（Moral Injury）」があることに着目した。そこで、自殺予防支援者にも同様の傷つきが生じているという仮説のもと、研究１では自殺予防支援者のメンタルヘルスに焦点を当て、コロナ禍におけるモラル傷害のリスクを踏まえた自殺予防支援者の心理的負担を明らかにし、研究2では、その負担感を軽減するための心理的支援プログラムを開発、検証することを目的として研究を行った。
          </Text>
            <br />
            <Heading as='h2'>２．対象と方法</Heading>
            　研究１は、自殺予防の電話相談員と精神科医療従事者を対象にWebアンケート調査を実施し、職種別に短縮版ケスラー抑うつ尺度（K6）で5点以上の者を心理的負担ありとし、「コロナ禍で自殺予防支援を行う際にストレスや不安に感じたこと」との関連を見た。また、K6得点と感情労働やバーンアウト、モラル苦悩について問う6項目との相関係数を算出した。
            <br /> 　研究２では、Waiting list design controlによるRCTを実施し、介入群には2種類のEラーニング動画の視聴及び2回のオンライングループワークを実施した。その後、統制群にも同様の介入と調査を行った。両群にはモラルの理解度や対処の自信に関する９項目、倫理的効力感などの心理尺度や、業務上のジレンマとその解決策、感想などの自由記述からなるウェブアンケート調査を同時期に実施し、効果を検証した。
            <br />
            <br />
            <Heading as='h2'>3．結果</Heading>
            　研究1では、電話相談員において過重労働、自殺念慮者・未遂者対応の知識や技術、経験が不足していたこと、COVID-19に関する過剰な報道、クレーマー（過度な要求をしてくるもの）への対処に困ったことが心理的負担の高さに有意に関連していた。精神科医療従事者では、過重労働に加え、感染予防のために十分な治療・相談・ケアができなかったことが心理的負担の高さに有意に関連していた。また、K6との相関係数では、モラル苦悩を問う項目「自分や家族を犠牲にしてまで働かなくてはならないと感じる」、「自分も辛い状況なのに被支援者のために我慢しなくてはいけないと感じる」が高い値を示した。
            況なのに被支援者のために我慢しなくてはいけないと感じる」が高い値を示した。
            <br />　研究２では、モラルの理解度や対処の自信に関する９項目全てにおいて介入群、統制群ともに介入前後で有意な得点の向上がみられた。また、J-MES（倫理的効力感尺度）の得点の向上もみられたが、その他の心理尺度に有意な変化はみられなかった。自由記述からは、本プログラムがピアサポートとしての効果や、支援者の考え方の修正等の、認知の広がりに貢献していることが分かった。
            <br />
            <br />
            <Heading as='h2'>4．考察</Heading>
            　研究1は、自殺予防支援者のコロナ禍での心理的負担を明らかにした本邦初の研究である。過重労働やクレーマーへの対処、平時に行うことができていた治療や支援ができないことに加え、「自分や家族を大切にすべき」という倫理観や道徳心が、コロナ禍の自殺予防支援において揺らぎ、モラル傷害のリスクを高めたことが考えられる。これらは感染症や災害発生時だけでなく、平時にも起こり得る可能性がある。そのため、自殺予防のための地域資源の縮小を防ぐためには、今回明らかになった支援者の心理的負担の要因を正しく理解し、それに応じた対策を平時から検討し、実施していくことが重要である。
            <br />　研究２では、自殺予防支援者のモラルを維持するための認知の修正と対処行動を学習する心理支援プログラムを開発し、有用性を検証した。モラルの概念に関する教育効果、倫理的効力感が有意に向上したことからは、本プログラムがモラル傷害を予防するための対応力と、モラルの傷つきに対応する論理的思考力の向上に有効であることが示唆された。また、自由記述から、本プログラムがピアサポートとしての効果や、支援者の考え方の修正等の、認知の広がりに貢献していることが分かった。しかし、燃え尽きや抑うつ等の心理的負担に関する尺度の有意な変化は得られず、獲得したスキルを今後、現場でどう活かしていくか、また、その結果として支援者の心理面にどのような影響が生じるかについては、長期的な検証が必要と考えられた。
            <br />
            <br />
            <Heading as='h2'>5．結論</Heading>
            　コロナ禍の自殺予防電話相談員の心理的負担に関連する要因は、過重労働、自殺予防の研修が受けられないこと、COVID-19に関する過剰な報道、クレーマーへの対応に困っていることである。精神科医療従事者では、過重労働に加え、感染予防のために十分な治療・相談・ケアができなかったというジレンマを抱えたことである。
            <br />　また、自殺予防支援者のモラル傷害を予防するための心理的支援プログラムを開発し、有用性を検証した結果、本プログラムがモラル傷害を予防するための対応力と、モラルの傷つきに対応する論理的思考力の向上に有効であることが示唆された。
            <br />　今後は、プログラムの時期や対象人数、効果検証の精度を上げ、再検証を重ねることでプログラムの有効性を高め、自殺予防支援者の研修に取り入れるなど、社会実装を検討していく必要がある。

            <br />
            <br />
            <Heading as='h2'>参考文献</Heading>
            <ol type='1'>
              <li>
              Ujihara M, Tachikawa H, Takahashi A, Gen T, Cho Y: Factors Related to Psychological Distress in Suicide Prevention Supporters during the COVID-19 Pandemic. Int J Environ Res Public Health. 2023 Mar 12;20(6):4991. doi: 10.3390/ijerph20064991.
              </li>
            </ol>
            </div>
          </CardComponent>
        </Main>
      </Stack>
    </Layout>
  )
}

export default PageContact
